import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '@/api/client';
import type { CiterneEcartGroup, EnginConsommationRow, EnginConsommationGroupRow, EnginGasoilRow, EnginChartFilter } from '@/types';
import {
  setCiternesEcart,
  setEnginConsommationTable,
  setEnginConsommationLineChart,
  setEnginConsommationBarChart,
} from '../slices/chartSlice';

export const fetchCiterneEcart = createAsyncThunk<
  void,
  { date_b: string; date_f: string },
  { rejectValue: string }
>(
  'chart/fetchCiterneEcart',
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await api.get<{ data: CiterneEcartGroup[] }>('/citernes/ecart', {
        params: { ...params, grouped: true },
      });
      dispatch(setCiternesEcart(Array.isArray(data?.data) ? data.data : []));
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : 'Erreur';
      return rejectWithValue(msg);
    }
  }
);

export const fetchEnginConsommationTable = createAsyncThunk<
  void,
  EnginChartFilter,
  { rejectValue: string }
>(
  'chart/fetchEnginConsommationTable',
  async (filter, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await api.post<{ data: EnginConsommationRow[] }>(
        '/citernes/sorties/consommations/engin',
        filter
      );
      dispatch(setEnginConsommationTable(Array.isArray(data?.data) ? data.data : []));
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : 'Erreur';
      return rejectWithValue(msg);
    }
  }
);

export const fetchEnginConsommationLineChart = createAsyncThunk<
  void,
  EnginChartFilter,
  { rejectValue: string }
>(
  'chart/fetchEnginConsommationLineChart',
  async (filter, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await api.post<{ data: EnginConsommationGroupRow[] }>(
        '/engins/consommations',
        filter
      );
      dispatch(setEnginConsommationLineChart(Array.isArray(data?.data) ? data.data : []));
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : 'Erreur';
      return rejectWithValue(msg);
    }
  }
);

export const fetchEnginConsommationBarChart = createAsyncThunk<
  void,
  EnginChartFilter,
  { rejectValue: string }
>(
  'chart/fetchEnginConsommationBarChart',
  async (filter, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await api.post<{ data: EnginGasoilRow[] }>(
        '/engins/gasoile/consommations',
        filter
      );
      dispatch(setEnginConsommationBarChart(Array.isArray(data?.data) ? data.data : []));
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : 'Erreur';
      return rejectWithValue(msg);
    }
  }
);
